import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'

import { hfComplianceApi } from '@atheneum/api'
import { formatDate } from '@atheneum/api/dist/lib'

class HFComplianceStatus extends Component {
  static propTypes = {
    growlStore: PropTypes.object.isRequired,
    expert: PropTypes.object.isRequired,
    hfCompliances: PropTypes.object.isRequired,
    className: PropTypes.string,
    callback: PropTypes.func,
    history: PropTypes.object
  }

  sendRequest = async e => {
    e.stopPropagation()
    e.preventDefault()
    const { growlStore, expert, callback } = this.props
    try {
      await hfComplianceApi.sendRequest(expert.userId)
      growlStore.showSuccess('HF Compliance request sent.')
      callback && (await callback())
    } catch (error) {
      growlStore.showError(error)
    }
  }

  render () {
    const { expert, hfCompliances, className, history } = this.props

    const classes = className
      ? `compliance-wrapper ${className}`
      : 'compliance-wrapper'

    // Take the first ones as they are sorted by created_at DESC on backend
    const latestRejectedHfCompliance = hfCompliances.find(
      hfc => hfc.isConfirmed === false
    )
    const latestConfirmedHfCompliance = hfCompliances.find(
      hfc => hfc.isConfirmed === true
    )
    const latestUnconfirmedHfCompliance = hfCompliances.find(
      hfc => hfc.isConfirmed === null
    )
    if (latestRejectedHfCompliance) {
      return (
        <div className={classes}>
          <span className='code-label m-r-md'>HF Compliance rejected.</span>
        </div>
      )
    } else if (latestUnconfirmedHfCompliance) {
      return (
        <div className={classes}>
          <span className='danger-label m-r-md'>
            HF Compliance verification pending.
          </span>
          <span
            className='action-label link'
            onClick={e => {
              e.stopPropagation()
              e.preventDefault()
              history.push(
                `/expert/${expert.userId}/hf-compliance/${
                  latestUnconfirmedHfCompliance.id
                }`
              )
            }}
          >
            Review compliance
          </span>
        </div>
      )
    } else if (latestConfirmedHfCompliance && expert.hfComplianceRequestedBy) {
      return (
        <div className={classes}>
          <span className='code-label m-r-md'>
            HF Compliance in place since{' '}
            {formatDate(latestConfirmedHfCompliance.createdAt)}, renewal
            requested.
          </span>
          <span className='action-label link' onClick={this.sendRequest}>
            Repeat request
          </span>
        </div>
      )
    } else if (latestConfirmedHfCompliance) {
      return (
        <div className={classes}>
          <span className='code-label m-r-md'>
            HF Compliance in place since{' '}
            {formatDate(latestConfirmedHfCompliance.createdAt)}.
          </span>
          <span className='action-label link' onClick={this.sendRequest}>
            Request renewal
          </span>
        </div>
      )
    } else if (expert.hfComplianceRequestedBy) {
      return (
        <div className={classes}>
          <span className='danger-label m-r-md'>HF Compliance requested.</span>
          <span className='action-label link' onClick={this.sendRequest}>
            Repeat request
          </span>
        </div>
      )
    } else {
      return (
        <div className={classes}>
          <span className='danger-label m-r-md'>
            HF Compliance not in place.
          </span>
          <span className='action-label link' onClick={this.sendRequest}>
            Request hedge fund compliance
          </span>
        </div>
      )
    }
  }
}

export default withRouter(inject('growlStore')(observer(HFComplianceStatus)))
